const debug = () => import(/* webpackChunkName: "debug" */ './pages/index.vue')
const selectShop = () => import(/* webpackChunkName: "selectShop" */ './pages/shop.vue')
const bridgeTest = () => import(/* webpackChunkName: "bridgeTest" */ './pages/bridge-test.vue')

export default [
  { path: '/debug', component: debug },
  { path: '/debug/select-shop', component: selectShop },
  { path: '/debug/bridge-test', component: bridgeTest },
]
